export class DebugDelay {
  static value = 0;
}
